module.exports = __webpack_public_path__ + "fonts/Gotham-Thin.3299606e.otf";